import {
	Box,
	Button,
	Chip,
	CircularProgress,
	Grid,
	Theme,
	Typography,
	useTheme,
} from "@mui/material";
import {
	COUNTRY_LIST_SCREEN_SLUG,
	INITIAL_PAGE_SIZE,
	INITIAL_SNACKBAR_DATA,
	ROWS_PER_PAGE_PER_OPTIONS,
	SEARCH_DEBOUNCE_DELAY_IN_SECONDS,
} from "../../common/constants";
import { DataGrid, GridFooterContainer } from "@mui/x-data-grid";
import {
	DeleteConfirmationDialog,
	EmptyList,
	EnhancedSnackbar,
	RouterLinkButton,
} from "@websential/cosmic-v20";
import { ICountry, IGetListRequest } from "../../models";
import { IResponse, IServerError } from "../../models/common";
import { Link, useNavigate } from "react-router-dom";
import React, { useCallback, useEffect, useMemo, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";

import { ComponentState } from "../../common/enums";
import { CountryService } from "../../services/CountryService";
import { IAppState } from "../../store/reducers";
import { PrimeDataGrid } from "../PrimeDataGrid";
import SearchIcon from "@mui/icons-material/Search";
import { setSelectedActivityLogActions } from "../../store/actions/activityLogActions";
import { setSelectedDrawerOptionsMenu } from "../../store/actions/drawerMenuOptionsActions";
import { setSelectedStickyNavBar } from "../../store/actions/stickyNavBarActions";
import { useNavigateToLogout } from "../../common/Common";

// import { toSnake } from "common/methods";
// import { countryList } from "components/Accountant/countryList";

// import { IcountryListPayload } from "models/accountant";






// import { EnhancedDDLBulkAction } from "@websential/ws-react-ui/lib/components/EnhancedDDLBulkAction";
// import { EnhancedDialog } from "@websential/ws-react-ui/lib/components/EnhancedDialog";
// import { ErrorState } from "@websential/ws-react-ui/lib/components/ErrorState/ErrorState";
// import { StatusChip } from "@websential/ws-react-ui/lib/components/StatusChip";

// import { clearError } from "store/actions/viewStateActions";






// import { EnhancedDataGrid } from "../../EnhancedDataGrid";
// import { newData } from "services";
// import OnRowDelete from "./OnRowDelete";






// import { fetchAccountantRequest } from "store/actions/getListActions";

export interface ICountryList { }
const COUNTRY_LIST_QUERY_KEY: any = "country-list";

const useCountry = (
	params: IGetListRequest,
	navigateToLogout: (path: string) => void
) =>
	useQuery({
		queryKey: ["country-list", params],
		queryFn: () => CountryService.getCountry(params, navigateToLogout),
		refetchOnWindowFocus: false,
	});

export const CountryList: React.FC<ICountryList> = () => {
	const theme = useTheme();
	const navigate = useNavigate();
	const dispatch = useDispatch();
	const isAdminUser = useSelector(
		(state: IAppState) => state.user.profile.isSuperStatus
	);
	const drawerMenuOptions = useSelector(
		(state: IAppState) => state.drawerMenu.menu
	);

	// for delete row Purpose
	const queryClient = useQueryClient();
	const [snackbarData, setSnackbarData] = useState(INITIAL_SNACKBAR_DATA);
	const [selectedRowsValues, setSelectedRowsValues] = useState([]);

	// Bulk Delete
	const [bulkDelete, setBulkDelete] = useState<boolean>(false);
	const [bulkCountryId, setBulkCountryId] = useState<any>({});
	const [bulkCountryDelete, setBulkCountryDelete] = useState<boolean>(false);

	const [queryParams, setQueryParams] = useState<IGetListRequest>({
		search_query: "",
		order_by: "firstName",
		order_direction: "asc",
		page: 1,
		size: 25,
	});
	const navigateToLogout = useNavigateToLogout();
	const { isPending, data } = useCountry(queryParams, navigateToLogout);
	const countryList: any = data;


	const { message, componentState } = useSelector(
		(state: IAppState) => state.viewState
	);

	// const { countryList } = useSelector(
	//   (state: IAppState) => state.accountant
	// );

	const [openDialog, setDialogOpen] = useState(false);
	const [selectedIds, setSelectedIds] = useState("");
	const [statusValue, setStatusValue] = useState("");
	const [apiAction, setApiAction] = useState("");
	const [emptyList, setEmptyList] = useState(false);
	const [searchText, setSearchText] = useState({});
	const [zeroCountry, setzeroCountry] = useState<any>(true);

	// for delete row
	const [singleDelete, setSingleDelete] = useState<boolean>(false);
	const [countryId, setCountryId] = useState<any>(0);

	const onRequestParamsChange = useCallback((requestParams: any) => {

		// let dispatchParams = {
		//   search_query: requestParams.debouncedSearchQuery,
		//   order_by: "acc_title",
		//   order_direction: "asc",
		//   page: requestParams.currentPage + 1,
		//   size: requestParams.pageSize,
		// };
		// if (requestParams.sort) {
		//   const [sortBy, sortDirection] = requestParams.sort.split(",");
		//   // dispatchParams.order_by = toSnake(sortBy);
		//   dispatchParams.order_direction = sortDirection;
		// }

		// if(dispatchParams.search_query === ''){
		//   setQueryParams(dispatchParams);
		// }
		// setSearchText(dispatchParams)
		let dispatchParams = {
			search_query: requestParams.searchQuery ? requestParams.searchQuery : "",
			order_by: "firstName",
			order_direction: requestParams.sortOrder
				? requestParams.sortOrder
				: "asc",
			page: requestParams.page + 1,
			size: requestParams.rows,
		};
		// if (requestParams.sort) {
		//   const [sortBy, sortDirection] = requestParams.sort.split(",");
		//   dispatchParams.order_by = toSnake(sortBy);
		//   dispatchParams.order_direction = sortDirection;
		// }

		setQueryParams(dispatchParams);
	}, []);

	const onSearchButtonClicked = () => {
		setQueryParams(searchText);
		setzeroCountry(false);
	};

	const onRowEditClicked = useCallback((params: ICountry) => {
		// alert(`Edit row with ID: ${params.row.id} has been clicked!`);
		let path = `/country/setup/${params.id}`;
		navigate(path);
	}, []);

	// When Delete Button Clicked

	// const onRowDeleteClicked = useCallback((data) => {
	//   setDialogOpen(true);
	//   setApiAction("delete");
	//   setSelectedIds(data.row.id);

	//   alert(`Delete row with ID: ${data.row.id} has been clicked!`);
	//   return CountryService.delAccountants(data.row.id);
	// }, []);

	const onCloseHandler = () => {
		setDialogOpen(false);
	};

	const deleteCountryField = () => {
		if (singleDelete) {
			setSingleDelete(false);
			let payload: any = {
				countryId: countryId,
				navigateToLogout: navigateToLogout,
			};
			deleteCountryById(payload);
			setDialogOpen(false);
		}
	};
	const onRowDeleteClicked = useCallback((params: ICountry) => {
		setDialogOpen(true);
		setSingleDelete(true);
		setCountryId(params.id);

		// if(singleDelete === true){

		// return (
		//   <OnRowDelete name={ACCOUNTANT_LIST_QUERY_KEY} id={params.row.id}/>
		//   )
		// }
	}, []);

	const onSnackbarClosed = (
		event: React.SyntheticEvent | Event,
		reason?: string
	) => {
		if (reason === "clickaway") {
			return;
		}
		setSnackbarData(INITIAL_SNACKBAR_DATA);
	};

	const { isPending: isDeleting, mutate: deleteCountryById } = useMutation({
		mutationFn: CountryService.delCountry,
		onSuccess: (res: string | IServerError | IResponse | any) => {
			if (res) {
				// remove the cache of the Accountant fields since we just added a new field.
				setSnackbarData({
					open: true,
					message: res.message ? res.message : "Something went wrong.",
					severity: res.success === false ? "error" : "success",
				});

				return queryClient.invalidateQueries(COUNTRY_LIST_QUERY_KEY);
			} else {
				setSnackbarData({
					open: true,
					message: "Something went wrong, try again later!",
					severity: "error",
				});
			}
		},
		onError: (err) => {
			// TODO: customize the toast message based on the response
			setSnackbarData({
				open: true,
				message: "Something went wrong, try again later!",
				severity: "error",
			});
		},
	});

	//bulk delete

	const { isPending: isBulkDeleting, mutate: deleteBulkCountry } = useMutation({
		mutationFn: CountryService.delBulkCountry,
		onSuccess: (res: any | string | IServerError | IResponse) => {
			if (typeof res === "object") {
				// remove the cache of the Year fields since we just added a new field.
				setSnackbarData({
					open: true,
					message: res.message ? res.message : "Something went wrong.",
					severity: res.success === false ? "error" : "success",
				});

				setBulkCountryDelete(false);
				return queryClient.invalidateQueries(COUNTRY_LIST_QUERY_KEY);
			} else {
				setSnackbarData({
					open: true,
					message: res.message
						? res.message
						: "Something went wrong, try again later!",
					severity: res.success === false ? "error" : "success",
				});
			}
			setBulkCountryDelete(false);
		},
		onError: (err: any) => {
			// TODO: customize the toast message based on the response
			setSnackbarData({
				open: true,
				message: err.message,
				severity: "error",
			});
			setBulkCountryDelete(false);
		},
	});

	// For Bulk Delete
	const deleteBulkCountryField = () => {
		if (bulkDelete) {
			setBulkDelete(false);
			let payload = {
				bulkCountryId: bulkCountryId,
				navigateToLogout: navigateToLogout,
			};
			deleteBulkCountry(payload);
			setDialogOpen(false);
		}
	};

	const onRowMultipleDeleteClicked = (params: any) => {

		let bulkDeletePayload = {
			countryIds: { countryIds: params },
		};
		setDialogOpen(true);
		setBulkDelete(true);
		setApiAction("delete");
		setBulkCountryId(bulkDeletePayload);
		setBulkCountryDelete(true);
	};

	const selectionToolbar = useCallback(
		(selectedItems: any) => {
			setSelectedIds(selectedItems);


			if (selectedItems.length) {
				return (
					<Box sx={{ marginTop: theme.spacing(1) }}>
						{/* {"Bulk Action Drop Down List"} */}
						{/* <EnhancedDDLBulkAction
            label="Status"
            value={statusValue}
            onChangeHandler={handleChange}
            options={[
              { name: "Active", value: "1" },
              { name: "Inactive", value: "2" },
            ]}
            testId="status-dd"
          /> */}
						<Button
							onClick={() => onRowMultipleDeleteClicked(selectedItems)}
							variant="contained"
							color="error"
						>
							Delete
						</Button>
					</Box>
				);
			}
			return (
				<>
					{isAdminUser === 400 ? (
						<Box sx={{ marginTop: theme.spacing(1) }}>
							<RouterLinkButton to="/country/setup" text="Add Country" />
						</Box>
					) : (
						<></>
					)}
				</>
			);
		},
		[selectedRowsValues]
	);

	const getColumnMinWidth = (field: any) => {
		const maxContentWidth = Math.max(
			...countryList?.items.map((row: any) => String(row[field]).length * 8)
		); // Assuming an average character width of 8px
		return maxContentWidth + 16; // Add some padding
	};

	const upadtedCompantListItems = useMemo(() => {
		return (
			countryList &&
			countryList.items &&
			countryList?.items.map((item: any) => ({
				...item,
				name: (
					<Link
						to={`/country/setup/${item.id}`}
						className="no-underline"
						style={{ color: theme.palette.primary.light }}
					// onClick={() => onClickHandler(item)}
					>
						{item.name}
					</Link>
				),
			}))
		);
	}, [countryList]);

	const expandedLabels = ["Misc.", "Country"];
	const expandedBanckListItem = "List";
	const enhanceData = (data: any[], parentLabel?: string): any[] => {
		return data.map((item) => {
			let isExpanded = expandedLabels.includes(item.label);
			if (parentLabel === "Country" && item.label === expandedBanckListItem) {
				isExpanded = true;
			}
			const enhancedItem = {
				...item,
				expanded: isExpanded,
				items: item.items ? enhanceData(item.items, item.label) : undefined,
			};
			return enhancedItem;
		});
	};
	useEffect(() => {
		dispatch(
			setSelectedActivityLogActions({
				entityId1: "",
				entityId2: "",
				entityId3: "",
				screenName: COUNTRY_LIST_SCREEN_SLUG,
				companyName: "",
				activityType: "activity_type=delete",
				activityLogVisibility: true,
			})
		);
		dispatch(setSelectedStickyNavBar({ isSticky: false }));
		if (drawerMenuOptions && drawerMenuOptions.length > 0) {
			const enhancedData = enhanceData(drawerMenuOptions);
			dispatch(setSelectedDrawerOptionsMenu({ menu: enhancedData }));
		}
	}, [drawerMenuOptions]);

	const image =
		"https://taxslips.blob.core.windows.net/taxslips-public-images-container/empty_employee_list.png";

	return countryList &&
		countryList.items &&
		countryList.items.length === 0 &&
		isAdminUser === 400 &&
		zeroCountry === true ? (
		<EmptyList
			showImage={true}
			imagePath={image}
			heading={`There's nothing! Add Country to proceed`}
			content={`You can add country by directly clicking on add country button.`}
			testId={"country-empty-list"}
			showAddButton={true}
			addButtonLabel={"Add Country"}
			navigateToAdd={"/country/setup"}
			showImportButton={false}
			showImportXmlButton={false}
		/>
	) : (
		<>
			<Grid
				size={{ xs: 12, sm: 12, md: 12, lg: 12, xl: 12 }}
			// className={classes.list}
			>
				{/* <EnhancedDialog
        dialogTitle="Please Confirm"
        key="dialog-box"
        testId="dialog"
        onCloseHandler={onCloseHandler}
        open={openDialog}
        dialogContent={
          <Typography variant="subtitle1">Are you sure?</Typography>
        }
        dialogAction={
          <Grid>
            <Button
              autoFocus
              variant="contained"
              onClick={onCloseHandler}
              color="default"
              className={classes.button}
            >
              Cancel
            </Button>
            <Button
              autoFocus
              variant="contained"
              onClick={callAction}
              color="primary"
              className={classes.button}
            >
              ok
            </Button>
          </Grid>
        }
      /> */}
				<DeleteConfirmationDialog
					open={openDialog}
					deleteActionHandler={
						bulkCountryDelete === true
							? deleteBulkCountryField
							: deleteCountryField
					}
					cancelActionHandler={onCloseHandler}
					testId="Country-field-tab-confirmation-dialog"
				/>
				{/* <EnhancedDataGrid
          keyField={countryList ? countryList.keyField : undefined}
          onKeyFieldClickHandler={onKeyFieldClickHandler}
          columns={countryList && countryList.headerColumns ? columnsWithMinWidth : []}
          rows={countryList?.items}
          selectionEnabled={isAdminUser === 400 ? true : false}
          autoHeight={true}
          allowSearching={true}
          onSearchButtonClicked={onSearchButtonClicked}
          searchFieldPlaceholder={"Search by Account Title..."}
          rowsPerPageOptions={ROWS_PER_PAGE_PER_OPTIONS}
          selectionToolbar={selectionToolbar}
          onRowEditClicked={onRowEditClicked}
          // onRowDeleteClicked={<OnRowDelete name={ACCOUNTANT_LIST_QUERY_KEY}/>}
          onRowDeleteClicked={onRowDeleteClicked}
          // initialPage={0}
          initialPageSize={INITIAL_PAGE_SIZE}
          disableColumnMenu={true}
          showRowActionsColumn={isAdminUser === 400 ? true : false}
          autoPageSize={false} //
          showIndexColumn={true}
          testId="accountant-list-grid"
          sortingMode="server"
          filterMode="server"
          paginationMode="server"
          onRequestParamsChange={onRequestParamsChange}
          onSearchCrossClicked={(value) => setzeroAccountant(value)}
          totalRowsCount={countryList?.total}
          isPending={isPending || isDeleting || isBulkDeleting}
          rowIdGetter={(row) => row.id}
          searchDebouncingDelay={SEARCH_DEBOUNCE_DELAY_IN_SECONDS}
          shouldMask={false}
        /> */}
				{/* <OnRowDelete name={ACCOUNTANT_LIST_QUERY_KEY} id={9}/> */}
				{/* <OnRowDelete name={ACCOUNTANT_LIST_QUERY_KEY} id={accountantId}/> */}

				<PrimeDataGrid
					columns={countryList ? countryList.headerColumns : []}
					rows={
						countryList && upadtedCompantListItems
							? upadtedCompantListItems
							: []
					}
					showIndexColumn={true}
					showChecboxColumn={isAdminUser === 400 ? true : false}
					showSettingColumn={true}
					onRowEditClicked={onRowEditClicked}
					onRowDeleteClicked={onRowDeleteClicked}
					isLoading={isPending || isDeleting || isBulkDeleting}
					onSnackbarMessageData={(value: any) => setSnackbarData(value)}
					totalRecords={
						countryList && countryList.total ? countryList.total : 0
					}
					initialPageSize={INITIAL_PAGE_SIZE}
					rowsPerPageOptions={ROWS_PER_PAGE_PER_OPTIONS}
					onRequestParamsChange={onRequestParamsChange}
					selectionToolbar={selectionToolbar}
					selectedRowsValues={(value: any) => setSelectedRowsValues(value)}
					searchFieldPlaceholder={"Search by Country Name..."}
					changeLoginForGetEmptyItemsBySearchQuery={(value: any) =>
						setzeroCountry(value)
					}
				/>
			</Grid>
			<EnhancedSnackbar
				message={snackbarData.message}
				onCloseHandler={onSnackbarClosed}
				severity={snackbarData.severity}
				testId={"accountant-field-tab-list-snackbar"}
				open={snackbarData.open}
			/>
		</>
	);
	// switch (componentState) {
	//   case ComponentState.LOADING:
	//     return (
	//       <CircularProgress
	//         size={24}
	//         data-testid="circular-progress"
	//         className={classes.loader}
	//       />
	//     );
	//   case ComponentState.ERROR:
	//     return (
	//       <div>Error loading component data</div>
	//       // <ErrorState
	//       //   testId="error-container"
	//       //   message={message}
	//       //   onClick={() => {
	//       //     clearError();
	//       //     let dispatchParams = {
	//       //       search_query: "",
	//       //       order_by: "acc_title",
	//       //       order_direction: "asc",
	//       //       page: 1,
	//       //       size: 50,
	//       //     };
	//       //     dispatch(countryListRequest(dispatchParams));
	//       //   }}
	//       // />
	//     );
	//   case ComponentState.DATA:
	//     return emptyList ? (
	//       <countryList />
	//     ) : (
	//       <Grid
	//         item
	//         xs={12}
	//         sm={12}
	//         md={12}
	//         lg={12}
	//         xl={12}
	//         className={classes.list}
	//       >
	//         {/* <EnhancedDialog
	//           dialogTitle="Please Confirm"
	//           key="dialog-box"
	//           testId="dialog"
	//           onCloseHandler={onCloseHandler}
	//           open={openDialog}
	//           dialogContent={
	//             <Typography variant="subtitle1">Are you sure?</Typography>
	//           }
	//           dialogAction={
	//             <Grid>
	//               <Button
	//                 autoFocus
	//                 variant="contained"
	//                 onClick={onCloseHandler}
	//                 color="default"
	//                 className={classes.button}
	//               >
	//                 Cancel
	//               </Button>
	//               <Button
	//                 autoFocus
	//                 variant="contained"
	//                 onClick={callAction}
	//                 color="primary"
	//                 className={classes.button}
	//               >
	//                 ok
	//               </Button>
	//             </Grid>
	//           }
	//         /> */}
	//         <EnhancedDataGrid
	//           columns={countryList ? countryList.headerColumns : []}
	//           rows={countryList?.items}
	//           selectionEnabled={true}
	//           autoHeight={true}
	//           allowSearching={true}
	//           rowsPerPageOptions={[10, 25, 50, 100]}
	//           selectionToolbar={selectionToolbar}
	//           onRowEditClicked={onRowEditClicked}
	//           onRowDeleteClicked={onRowDeleteClicked}
	//           initialPageSize={countryList?.size}
	//           disableColumnMenu={true}
	//           showRowActionsColumn={true}
	//           autoPageSize={true}
	//           showIndexColumn={true}
	//           testId="accountant-list-grid"
	//           sortingMode="server"
	//           filterMode="server"
	//           paginationMode="server"
	//           onRequestParamsChange={onRequestParamsChange}
	//           totalRowsCount={countryList?.total}
	//           isPending={false}
	//           rowIdGetter={(row) => row.id}
	//           searchDebouncingDelay={2000}
	//           shouldMask={false}
	//         />
	//       </Grid>
	//     );
	//   default:
	//     return null;
	// }
};
